import { Link } from "react-router-dom";
import type { QueueTile } from "../../api/dashboard";

/** What is waiting on the office, first, because it is the reason to open the
 * dashboard at all. Each tile is the whole link: the number says how much, the
 * words say what to do, and the tile goes where it is done. */
export function OfficeQueue({ tiles }: { tiles: QueueTile[] }) {
  if (tiles.length === 0) {
    return null;
  }
  return (
    <section className="dash-queue" aria-labelledby="dash-queue-label">
      <h2 id="dash-queue-label" className="section-label">
        Waiting on the office
      </h2>
      <div className="queue-tiles">
        {tiles.map((tile) => (
          <Link key={tile.key} to={tile.href} className={`queue-tile tone-${tile.tone}`}>
            {/* A problem count is red only while there is a problem; a zero
                in red reads as an alarm about nothing. */}
            <span className={tile.tone === "crit" && tile.value > 0 ? "queue-value alert" : "queue-value"}>
              {tile.value}
            </span>
            <span className="queue-label">{tile.label}</span>
            <span className="queue-action">{tile.action} →</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
